import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]
  static values = { text: String }

  async copy() {
    await navigator.clipboard.writeText(this.textValue)
    this.labelTarget.textContent = "Token zkopírován"
    window.setTimeout(() => {
      this.labelTarget.textContent = ""
    }, 1800)
  }
}
